import React, { useState } from "react";

const useSelectRange = (options, values) => {
  const [lastClicked, setLastClicked] = useState(null);

  const getSelections = (clickedOption, isShiftKey, isSelected) => {
    const selectedIndex = options.findIndex(option => option.value === clickedOption.value);
    const isDeselectRange = isShiftKey && lastClicked && !lastClicked.selected;
    const isSelectRange = isShiftKey && lastClicked && lastClicked.selected;

    const getRange = () => {
      const range =
        selectedIndex > lastClicked.index
          ? options.slice(lastClicked.index, selectedIndex + 1)
          : options.slice(selectedIndex, lastClicked.index);
      return range.filter(item => !item.disabled);
    };

    const deselectOption = () => values.filter(selected => selected.value !== clickedOption.value);
    const deselectRange = () => values.filter(selected => !getRange().find(item => item.value === selected.value));
    const selectOption = () => [...values, clickedOption];
    const selectRange = () => {
      const added = getRange().filter(item => !values.find(selected => selected.value === item.value));
      return [...values, ...added];
    };

    setLastClicked({ index: selectedIndex, selected: !isSelected });

    if (isSelected) {
      return isDeselectRange ? deselectRange() : deselectOption();
    }

    return isSelectRange ? selectRange() : selectOption();
  };

  return { getSelections, setLastClicked };
};

export default useSelectRange;
